import { medpraxSystem } from '@quromedical/fhir-common';
import type {
  ValueSet,
  ValueSetComposeInclude,
  ValueSetComposeIncludeConcept,
} from 'fhir/r4';
import type { MedpraxPageResult } from '../external-integrations';

export const mapToValueSetComposeIncludeConcept = (
  icd10Code: MedpraxPageResult,
): ValueSetComposeIncludeConcept | undefined => {
  const valueSetComposeIncludeConcept: ValueSetComposeIncludeConcept = {
    code: icd10Code.Code,
    display: icd10Code.Description,
  };

  return valueSetComposeIncludeConcept;
};

export const mapToValueSet = (
  valueSetComposeIncludeConcept: ValueSetComposeIncludeConcept[],
): ValueSet => {
  const valueSetComposeInclude: ValueSetComposeInclude = {
    system: medpraxSystem,
    concept: valueSetComposeIncludeConcept,
    version: '10',
  };

  const valueSet: ValueSet = {
    resourceType: 'ValueSet',
    status: 'active',
    name: 'ICD-10',
    compose: {
      include: [valueSetComposeInclude],
    },
  };

  return valueSet;
};
